/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Correct_FailedInputs */

const en_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to auto correct events based on reading rate`)
};

const fr_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la correction automatique des événements selon la vitesse de lecture`)
};

const de_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Korrektur von Ereignissen basierend auf der Lesegeschwindigkeit ist fehlgeschlagen.`)
};

const it_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile correggere automaticamente gli eventi in base alla velocità di lettura`)
};

const ru_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось автоматически скорректировать события на основе скорости чтения.`)
};

const es_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron corregir automáticamente los eventos según la velocidad de lectura`)
};

const zh_cn2_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据阅读速率自动更正事件失败`)
};

const ja_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み取り速度に基づいてイベントを自動修正できませんでした`)
};

const hi_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पठन दर के आधार पर घटनाओं को स्वतः ठीक करने में विफलता`)
};

const pt_pt2_auto_correct_failed = /** @type {(inputs: Auto_Correct_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na correção automática de eventos com base na taxa de leitura.`)
};

/**
* | output |
* | --- |
* | "Failed to auto correct events based on reading rate" |
*
* @param {Auto_Correct_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct_failed = /** @type {((inputs?: Auto_Correct_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Correct_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_correct_failed(inputs)
	if (locale === "de") return de_auto_correct_failed(inputs)
	if (locale === "it") return it_auto_correct_failed(inputs)
	if (locale === "ru") return ru_auto_correct_failed(inputs)
	if (locale === "es") return es_auto_correct_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_correct_failed(inputs)
	if (locale === "ja") return ja_auto_correct_failed(inputs)
	if (locale === "hi") return hi_auto_correct_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_correct_failed(inputs)
	return en_auto_correct_failed(inputs)
});